import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import { Router, Route, hashHistory, useRouterHistory } from 'react-router'
import { browserHistory } from 'react-router'


import Summary from './components/Summary.react.js'
import ShopPage from './components/shoppage.react.js'

import reducer from './reducers'
export let store = createStore(reducer, applyMiddleware(thunk))

//const appHistory = useRouterHistory(createHashHistory)({ queryKey: false })

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
    <Route path="/" component={Summary}/>
    <Route path="/shop" component={ShopPage}/>
  </Router>
  </Provider>,
  document.getElementById('content')
);



// WEBPACK FOOTER //
// ./index.js